import React, { Component } from 'react'
import { connect } from 'react-redux'
import compose from 'lodash/fp/compose'

import errorBoundary from 'client/shared/decorators/error-boundary'

import { show as showAuthPopup } from 'client/shared/reducers/popup-reducer'
import {
  getCommentsByIds,
  add as addComment,
} from 'client/bookmate/reducers/comments-reducer'

import { CardCommentBox } from 'client/bookmate/boxes/card-comment-box'

import List from 'client/bookmate/blocks/list'
import CommentUnauthorized from 'client/bookmate/blocks/comment-unauthorized'
import { CommentForm } from 'client/bookmate/blocks/comment-form'
import { Dispatch, State as ConnectedState } from 'shared/types/redux'
import { CurrentUserState } from 'client/shared/types/current-user'

type Props = {
  resourceType: 'impressions' | 'quotes' | 'posts'
  resourceUuid: string
  dispatch: Dispatch
  currentUser: CurrentUserState
  comments: string[]
}

type State = {
  parent: React.ReactNode | null
  commentForm?: React.ReactNode
}

class _CommentsBox extends Component<Props, State> {
  state = {
    parent: null,
  }

  onLoginLinkClick = () => {
    this.props.dispatch(showAuthPopup())
  }

  onCommentAdd = content => {
    const { dispatch, resourceUuid, resourceType } = this.props

    dispatch(
      addComment(
        {
          content,
          resourceType,
          resourceUuid,
          parent: this.state.parent,
        },
        () => {
          this.setState({ parent: null })
        },
      ),
    )
  }

  onReplyClick = comment => {
    const {
      dispatch,
      currentUser: { auth },
    } = this.props

    if (!auth) {
      return dispatch(
        showAuthPopup({
          callback: () => {
            setTimeout(() => {
              if (this && this.commentForm) {
                this.setState({
                  parent: comment,
                })
                this.commentForm.focus()
              }
            }, 400)
          },
        }),
      )
    }

    this.setState({
      parent: comment,
    })
    this.commentForm.focus()
  }

  onReplyRemove = () => {
    this.setState({
      parent: null,
    })
  }

  render() {
    const { comments } = this.props

    return (
      <div>
        {Boolean(comments.length) && this.renderComments(comments)}
        {this.renderCommentForm()}
      </div>
    )
  }

  renderComments(comments) {
    return <List>{comments.map(this.renderComment)}</List>
  }

  renderComment = (comment, i) => {
    const { resourceType, resourceUuid } = this.props

    return (
      <CardCommentBox
        key={i}
        kind="thread"
        active={comment.recentlyAdded}
        comment={comment}
        onReplyClick={this.onReplyClick}
        resourceType={resourceType}
        resourceUuid={resourceUuid}
        showAuthPopup={showAuthPopup}
      />
    )
  }

  renderCommentForm() {
    const { currentUser } = this.props

    return currentUser.auth ? (
      <CommentForm
        ref={element => (this.commentForm = element)}
        currentUser={currentUser.data}
        onCommentAdd={this.onCommentAdd}
        onReplyRemove={this.onReplyRemove}
        parent={this.state.parent}
      />
    ) : (
      <CommentUnauthorized onLinkClick={this.onLoginLinkClick} />
    )
  }
}

const connectWrapper = connect((state: ConnectedState) => ({
  currentUser: state.currentUser,
  comments: getCommentsByIds(state, state.entities.comments.ids),
}))

const wrappers = compose(connectWrapper, errorBoundary)

export const CommentsBox = wrappers(_CommentsBox)
